var _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulldozerExcavator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 227.061,
    cy: 356.57,
    r: 16.761
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 294.107,
    cy: 356.57,
    r: 16.761
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 361.152,
    cy: 356.57,
    r: 16.761
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 428.198,
    cy: 356.57,
    r: 16.761
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M444.955,274.448v-152.54c0-27.727-22.557-50.284-50.284-50.284H284.741c-21.677,0-40.849,13.817-47.704,34.383 c-20.359,61.082-26.742,74.657-26.742,104.707v63.733c-12.379,2.523-23.773,7.785-33.523,15.121v-102.26 c0-7.379-4.825-13.89-11.885-16.037c-7.058-2.145-14.692,0.576-18.801,6.706L7.049,385.468 c-17.117,22.441-1.13,54.908,27.205,54.908h92.235c17.87,0,33.581-9.377,42.501-23.463c15.075,14.512,35.54,23.463,58.067,23.463 h201.137c46.211,0,83.807-37.596,83.807-83.807C512,316.096,483.162,282.236,444.955,274.448z M143.25,390.091 c0,9.242-7.519,16.761-16.761,16.761H34.254c-1.986,0-6.768,8.338,108.996-164.421V390.091z M250.312,172.193h94.074v33.523 H243.929C244.456,193.316,246.712,182.997,250.312,172.193z M243.818,239.238h117.33c9.257,0,16.761-7.505,16.761-16.761v-67.046 c0-9.257-7.505-16.761-16.761-16.761h-99.661l7.354-22.061c2.285-6.855,8.676-11.461,15.901-11.461H394.67 c9.242,0,16.761,7.519,16.761,16.761v150.852H243.818V239.238z M428.193,406.852H227.057c-27.727,0-50.284-22.557-50.284-50.284 s22.557-50.284,50.284-50.284h201.137c27.727,0,50.284,22.557,50.284,50.284S455.92,406.852,428.193,406.852z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulldozerExcavator);
export default __webpack_public_path__ + "static/media/bulldozer-excavator.2750dee0a8b8b36c605a5fe7e0e7ba75.svg";
export { ForwardRef as ReactComponent };